var arrScroll = [];

let TableScroll = {
    init: function(tableScroll){

        tableScroll.each(function(index, value){
            let $scrollerWrap = $(this);

            if(!$scrollerWrap.hasClass('init')){
                let $table = $scrollerWrap.find('table'),
                    myScroll;

                $scrollerWrap.addClass('init');

                if (!($scrollerWrap.find('.scroll-content').length)){
                    $scrollerWrap.wrapInner('<div class="scroll-content"></div>');
                    $scrollerWrap.append('<div class="scroll-left"></div><div class="scroll-right"></div>');

                    $scrollerWrap.find('.scroll-content').css('min-width', $table.outerWidth() + 'px');
                }
                $scrollerWrap.addClass('table-scroll_' + index).attr('data-scroll-index', index);

                TableScroll.initScrollContent('.table-scroll_' + index, myScroll, index);
            }
        });
    },
    // плагин iScroll
    setArrow: function(myScroll, left, right){
        if (myScroll.x == 0) {
            left.hide();
        } else if (myScroll.x < 0) {
            left.show();
        }
        if (myScroll.x == myScroll.maxScrollX) {
            right.hide();
        } else if (myScroll.x > myScroll.maxScrollX) {
            right.show();
        }
    },
    updateScrollContent: function(index) {
        var myScroll = arrScroll[index];

        setTimeout(function () {
            var $wrapper = $(myScroll.wrapper),
                $left = $wrapper.find('.scroll-left'),
                $right = $wrapper.find('.scroll-right'),
                $table = $wrapper.find('table'),
                $tableContent = $wrapper.find('.scroll-content');

            // Устанавливаем минимальную ширину в auto, чтобы корректно посчитать
            // ширину таблицы, а уже потом устанавливаем пересчитанную минимальную ширину контейнера
            $tableContent.css('min-width', 'auto');
            $tableContent.css('min-width', $table.outerWidth() + 'px');

            myScroll.refresh();
            TableScroll.setArrow(myScroll, $left, $right);
        }, 0);
    },
    initScrollContent: function(elem, myScroll, index, $scrollerWrap) {
        myScroll = new IScroll(elem, {
            eventPassthrough: true,
            scrollX: true,
            scrollY: false,
            preventDefault: false,
            scrollbars: 'custom'
        });

        arrScroll[index] = myScroll;

        var $elem = $(elem),
            $scroller = $elem.find('.scroll-content'),
            $left = $elem.find('.scroll-left'),
            $right = $elem.find('.scroll-right');

        TableScroll.setArrow(myScroll, $left, $right);

        $('.main').on('click', elem + ' .scroll-left', function(){
            var step_scroll = (Math.abs(myScroll.maxScrollX)/2 < 100 ? Math.abs(myScroll.maxScrollX) : Math.abs(myScroll.maxScrollX)/2 + 10),
                x = (Math.abs(myScroll.x) > step_scroll ? step_scroll : Math.abs(myScroll.x));

            myScroll.scrollBy(x, 0, parseInt(x/10));
        });

        $('.main').on('click', elem + ' .scroll-right', function(){
            var step_scroll = (Math.abs(myScroll.maxScrollX)/2 < 100 ? Math.abs(myScroll.maxScrollX) : Math.abs(myScroll.maxScrollX)/2 + 10),
                x_max = Math.abs(myScroll.maxScrollX) - Math.abs(myScroll.x),
                x = (x_max < step_scroll ? x_max : step_scroll);

            myScroll.scrollBy(-1*x, 0, parseInt(x/10));
        });

        myScroll.on('scrollEnd', function() {
            TableScroll.setArrow(this, $left, $right);
        });

        $(window).on('resize', function(){
            TableScroll.updateScrollContent(index);
        });
    }
}

$(document).ready(function($) {

    let tableScroll = $('.table-scroll');
    if(tableScroll.length) {
        TableScroll.init(tableScroll);
    }
});

export default {
  init: TableScroll.init,
  updateContent: TableScroll.updateScrollContent
};


// WEBPACK FOOTER //
// ./components/table-scroll.js